import {BorderArticle} from "@/components/ui/general/BorderArticle";

import React, {useMemo} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {useEffectivenessContext} from "./EffectivenessContext";
import styles from "./styles.module.scss";

export const Conclusion = () => {
  const {t} = useTranslation();
  const {isMobile} = useSelector((state) => state.common.settings);
  const {
    currencySymbol,
    roiFromConfig,
    formatInteger,
    formatPaybackPeriod,
    effectivenessConfigWithReps,
  } = useEffectivenessContext();

  const items = useMemo(() => {
    const fmtEuro = (n) =>
      `${currencySymbol}${formatInteger(Math.round(Number(n) || 0))}`;
    const totalInvestment = roiFromConfig.TOTAL_YEAR_1_INVESTMENT;
    const netBenefitYear1 = roiFromConfig.NET_BENEFIT_REVISED;
    const roiPercent = Math.round(roiFromConfig.ROI_REVISED);
    const paybackMonths = roiFromConfig.PAYBACK_MONTHS_REVISED;
    const pilotBudget = roiFromConfig.SUBTOTAL_PILOT;

    return [1, 2, 3, 4].map((idx) => {
      const title = t(`page.effectiveness.conclusion.items.${idx}.title`);

      if (idx === 1) {
        return {
          id: idx,
          title,
          description: t("page.effectiveness.conclusion.items.1.description", {
            investment: fmtEuro(totalInvestment),
            net_benefit: fmtEuro(netBenefitYear1),
            roi: roiPercent,
            payback_period: formatPaybackPeriod(paybackMonths),
          }),
        };
      }

      if (idx === 3) {
        return {
          id: idx,
          title,
          description: t("page.effectiveness.conclusion.items.3.description", {
            payback_weeks: formatPaybackPeriod(
              roiFromConfig.PAYBACK_MONTHS_CONSERVATIVE,
            ),
          }),
        };
      }

      if (idx === 4) {
        return {
          id: idx,
          title,
          description: t(
            `page.effectiveness.conclusion.items.${idx}.description`,
            {pilot_budget: fmtEuro(pilotBudget)},
          ),
        };
      }

      return {
        id: idx,
        title,
        description: t(
          `page.effectiveness.conclusion.items.${idx}.description`,
        ),
      };
    });
  }, [t, roiFromConfig, currencySymbol, formatInteger, formatPaybackPeriod]);

  const repsDisplay = formatInteger(
    effectivenessConfigWithReps.workforce.number_of_medical_representatives,
  );

  return (
    <div className={styles.conclusion_wrapper}>
      <BorderArticle>
        <H3>
          <b
            style={{color: "var(--white)", fontSize: "28rem"}}
            dangerouslySetInnerHTML={{
              __html: t("page.effectiveness.conclusion.title"),
            }}
          />
        </H3>

        <RootDesc>
          <span
            style={{
              color: "var(--white)",
              fontSize: "23rem",
              lineHeight: "120%",
            }}
            dangerouslySetInnerHTML={{
              __html: t("page.effectiveness.conclusion.description", {
                reps: repsDisplay,
              }),
            }}
          />
        </RootDesc>

        <div className={styles.conclusion_items_wrapper}>
          {items.map((item) => {
            const isLast = item.id === items.length;

            return (
              <div
                key={item.id}
                className={`${styles.conclusion_item} ${
                  isLast ? styles.conclusion_item_last : ""
                }`}
              >
                <BorderArticle>
                  <H3>
                    <span
                      style={{
                        color: "var(--grey)",
                        fontSize: isLast && !isMobile ? "30rem" : "23rem",
                        lineHeight: "120%",
                      }}
                      dangerouslySetInnerHTML={{__html: item.title}}
                    />
                  </H3>

                  <RootDesc>
                    <span
                      style={
                        isLast && !isMobile
                          ? {fontSize: "28rem", lineHeight: "120%"}
                          : {fontSize: "23rem", lineHeight: "120%"}
                      }
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}
                    />
                  </RootDesc>
                </BorderArticle>
              </div>
            );
          })}
        </div>
      </BorderArticle>
    </div>
  );
};
